import { NavLink } from "react-router-dom";
import { useState } from "react";
import '../styles/navbar.css';
import logo from '../assets/dcbiomedical-name-only-logo.png';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const menus = [
    { name: "Home", path: "/" },
    { name: "Equipment Serviced", path: "/equipment" },
    { name: "About Us", path: "/about" },
    { name: "Contact Us", path: "/contact-us" }
  ];

  return (
    <>
      <header className="Navbar">
        <img src={logo} alt="dcbiomedical-logo" />

        {/* Hamburger */}
        <div
          className={`Hamburger ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
         {/* Sliding menu */}
      <nav className={`Menu-Items ${isOpen ? "open" : ""}`}>
        {menus.map((menu, i) => (
          <NavLink
            key={i}
            to={menu.path}
            className={({ isActive }) => (isActive ? "Menu-Item active" : "Menu-Item")}
            onClick={() => setIsOpen(false)} // close menu when link clicked
          >
            {menu.name.toUpperCase()}
          </NavLink>
        ))}
      </nav>
      </header>

     
    </>
  );
}

export default Navbar;
